/** HJ1-Sperre nach HJ2-Freigabe — zentral für UI + Store. */

export type HjLockFlags = {
    isHJ1GesperrtGlobal?: boolean;
    isHJ2Freigegeben?: boolean;
} | null | undefined;

/** True, wenn HJ1 nach HJ2-Freigabe gesperrt ist — gilt für Mandant UND Gott-Modus. */
export function isHj1ClientLocked(cd: HjLockFlags): boolean {
    return Boolean(cd?.isHJ1GesperrtGlobal) && Boolean(cd?.isHJ2Freigegeben);
}

/**
 * Store-Schreibschutz für HJ1: hart gesperrt für alle (auch Gott-Modus).
 * Sonst würden Live-Änderungen die eingefrorene HJ1-Akte zerstören.
 */
export function isHj1WriteBlocked(cd: HjLockFlags): boolean {
    return isHj1ClientLocked(cd);
}
